import { lang } from '@umu/ukit-lang';
import React, { Component } from 'react';
import './aiReportSection.scss';
import AiReportChart from './components/aiReportChart/aiReportChart';
import AiTags from './components/aiTags/aiTags';
import { DimensionType, IAiDimension, IAiDimensionData } from './types';
import { IAiReportData } from '@umu/umu-types/src/interface/aiReportInfo';
import { calclulateAvg, getMax, getTags, OVERVIEW_STRINGS, filterDimensions, getStarLevel } from './util';

interface IAiReportSectionProps {
    userName: string;
    aiReportInfo: IAiReportData;
    aiVoiceCheckSwitch?: number;
    expressiveMinScore?: number;
    expressiveFullScore?: number;
    ytmw_def_val?: number;
    allow_ytmw_cal_to_score?: number;
}

export default class AiReportSection extends Component<IAiReportSectionProps, {}> {
    public render() {
        const {
            aiVoiceCheckSwitch,
            aiReportInfo,
            expressiveMinScore,
            expressiveFullScore,
            allow_ytmw_cal_to_score,
            ytmw_def_val,
        } = this.props;
        if (!aiReportInfo) {
            return null;
        }
        const avg = calclulateAvg(aiReportInfo.ai_score, aiReportInfo.ai_weight, allow_ytmw_cal_to_score, ytmw_def_val);
        const dimensions = filterDimensions(aiReportInfo.ai_score, aiReportInfo.ai_weight, expressiveFullScore);
        return (
            <div className="ai-report-section">
                {this.renderTags(aiReportInfo.ai_label, avg)}
                {this.renderOverviewString(avg)}
                <div className="ai-report-chart">
                    <AiReportChart
                        aiVoiceCheckSwitch={aiVoiceCheckSwitch}
                        avg={avg}
                        dimensions={dimensions}
                        expressiveMinScore={expressiveMinScore}
                        expressiveFullScore={expressiveFullScore}
                    />
                </div>
            </div>
        );
    }

    /**
     * 超越的<80%，则不出「超越了多少人」这句，其他文案还是要出的
     * @param avg 分数平均值
     */
    private renderOverviewString(avg: number) {
        const starLevel = getStarLevel(avg, this.props.expressiveFullScore);
        // 小于4.5不显示
        if (starLevel && starLevel < 4.5) {
            return;
        }
        const { userName, aiReportInfo } = this.props;
        const data = this.convertDimensions2Array(aiReportInfo.ai_score);
        const maxDiment = getMax(data);
        let overviewString = this.getOverviewString(userName, aiReportInfo.rank_over, maxDiment);
        if (!starLevel) {
            overviewString = lang('AI回到了自己的星球，没能领悟你的作业');
        }
        return (
            <div className="ai-report-overview">
                <p>{overviewString}</p>
            </div>
        );
    }

    private getOverviewString(userName: string, rankOver: number, dimension: IAiDimension) {
        const percent = rankOver * 100 + '%';
        const rankOverString = rankOver > 0.8 ? lang(`你超越了{$0}的参与者！`, percent) : '';
        return `${userName}：${rankOverString}${OVERVIEW_STRINGS[dimension.type]}`;
    }

    private renderTags(labelIds: string[], avg: number) {
        // console.log('renderTags', avg);
        const expressiveFullScore = this.props.expressiveFullScore || 5;
        if (!avg) {
            return <div className="ai-report-homework-title">{lang('谜一样的作业')}</div>;
        }
        // 小于4.5不显示
        if (avg < 0.09 * expressiveFullScore) {
            return;
        }
        const tagData = getTags(labelIds);
        return <AiTags tags={tagData} />;
    }

    private convertDimensions2Array(dimensionsData: IAiDimensionData) {
        if (!dimensionsData) {
            return [];
        }
        const dimensionKeys = Object.keys(dimensionsData);
        return dimensionKeys.map((key) => {
            return {
                type: key as DimensionType,
                value: dimensionsData[key],
            };
        });
    }
}
